export const findGraphemeClusters = (input, returninput) => {
  const segmenter = new Intl.Segmenter("en", { granularity: "grapheme" });
  if (returninput)
    return (
      Array.from(segmenter.segment(input))
        .slice(0, 15)
        .map((item) => item.segment)
        .join("") + "..."
    );
  else return Array.from(segmenter.segment(input));
};
